import * as React from "react";
const SvgHold20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.664 19.167V5.833h-.014a2.019 2.019 0 0 0-2.356-2.255V3.43a2.013 2.013 0 0 0-2.018-2.008c-.284 0-.553.058-.798.163a2.02 2.02 0 0 0-3.439.501 2.023 2.023 0 0 0-2.52 1.957v5.483l-2.14-.765a1.296 1.296 0 0 0-1.374 2.117l-.003.003 5.496 5.99v2.297h9.166ZM10.26 2.848a.352.352 0 0 0-.704 0v.012l-.308 6.316H8.42l-.53-5.172a.353.353 0 0 0-.704.033v7.854l-2.968-1.062 4.948 5.393-.004.004h.003V17.5h5.834V5.834H15v-.272a.352.352 0 0 0-.704-.002l-.376 3.612h-.837l-.456-5.783h-.003a.348.348 0 0 0-.35-.301.348.348 0 0 0-.35.302v.008l-.346 5.799h-.838l-.482-6.321v-.028ZM2.944 9.976h-.01l.008.006.002-.006Z",
      clipRule: "evenodd"
    })
  );
export default SvgHold20Px;
